import logoImage from "@/assets/logo.jpg";
import { useUtmDetection, FunnelStage } from "@/hooks/useUtmDetection";

interface FunnelContent {
  headline: string;
  subheadline: string;
  socialProof: string | null;
}

const FUNNEL_CONTENT: Record<FunnelStage, FunnelContent> = {
  // Bottom funnel: Ready to take action - direct, solution-focused
  bottom: {
    headline: "Glândulas de Tyson e PPP: Métodos Clínicos de Remoção Comparados",
    subheadline: "Guia baseado em evidências comparando laser CO₂, eletrocauterização e protocolos caseiros. 2.347 casos documentados.",
    socialProof: "Veja a tabela de comparação clínica e os resultados dos tratamentos abaixo.",
  },
  // Middle funnel: Comparing options - show proof and differentiation
  middle: {
    headline: "Pápulas Peroladas Penianas: Entendendo Suas Opções de Tratamento",
    subheadline: "Comparação clínica dos métodos de remoção: custo, tempo de recuperação, taxas de eficácia e privacidade.",
    socialProof: "Confira dados baseados em evidências e documentação de antes/depois.",
  },
  // Top funnel: Just learning - educational, clinical approach
  top: {
    headline: "Glândulas de Tyson e Pápulas Peroladas Penianas (PPP): Visão Clínica e Métodos de Remoção",
    subheadline: "Guia completo cobrindo identificação, diagnóstico diferencial de DSTs e opções de tratamento baseadas em evidências (Atualizado 2026).",
    socialProof: null,
  },
};

const SalesLetterHero = () => {
  const { funnelStage } = useUtmDetection();
  const content = FUNNEL_CONTENT[funnelStage];

  return (
    <header className="mb-8 md:mb-12">
      {/* Logo */}
      <div className="flex flex-col items-center mb-8">
        <img 
          src={logoImage} 
          alt="Logo do Smooth P-nis Method" 
          className="w-16 h-16 md:w-20 md:h-20 object-contain rounded-2xl border-2 border-border/50 shadow-lg"
          width="80"
          height="80"
        />
        <span className="mt-2 text-base md:text-lg font-cursive text-foreground/70 tracking-wide">Smooth P-nis Method</span>
      </div>

      {/* Main Headline - Clinical H1 */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight text-center">
        {content.headline}
      </h1>

      {/* Sub-headline */}
      <p className="text-base md:text-lg text-muted-foreground text-center leading-relaxed max-w-2xl mx-auto">
        {content.subheadline}
      </p>

      {/* Clinical credibility badge */}
      <div className="mt-4 flex justify-center">
        <div className="inline-flex items-center gap-2 bg-muted/30 border border-border rounded-full px-4 py-2">
          <span className="text-xs text-muted-foreground">Última revisão: Janeiro de 2026</span>
          <span className="text-xs text-muted-foreground">|</span>
          <span className="text-xs text-muted-foreground">Conteúdo médico</span>
        </div>
      </div>

      {/* Social proof for campaign visitors */}
      {content.socialProof && (
        <p className="mt-4 text-sm md:text-base text-primary font-semibold text-center">
          {content.socialProof}
        </p>
      )}
    </header>
  );
};

export default SalesLetterHero;
